export type FilterDisplayStyle = 'with-background' | 'only-text';
